import { Button,  Divider,  TextField,  useTheme } from '@mui/material';
import { DateField, LocalizationProvider, MobileDateTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { clientsFinanceDetailsFn } from '../../../../services/clients';
import { useQuery } from 'react-query';
import Loading from '../../../shared/loading/loading';
import ClientesSalesTable from '../sales';
import CustomPeriodSelect from '../../../shared/CustomPeriodSelect';
import { useState } from 'react';


const ClienteFinanceDetails = (props) => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const { data: values, isLoading } = useQuery(["client-finance-details", props.client, startDate, endDate], 
                                                () => clientsFinanceDetailsFn({id: props?.client, 
                                                                                startDate: dayjs(startDate).format('YYYY-MM-DD'), 
                                                                                endDate: dayjs(endDate).format('YYYY-MM-DD')}));

    return (
    <div className="grid grid-cols-1 gap-2">
        <Loading open={isLoading} />
        <Divider sx={{ color: useTheme().palette.primary.main }} className=" font-bold text-12">
            Detalhes Financeiros
        </Divider>
        <div className="grid grid-cols-1 gap-2 lg:grid-cols-1 md:grid-cols-1 mb-2 ">
            <CustomPeriodSelect  label="Periodo" startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} />
        </div>
        <div className="grid grid-cols-1 gap-2 lg:grid-cols-2 md:grid-cols-2">
            <LocalizationProvider fullWidth dateAdapter={AdapterDayjs}>
                <DateField 
                    size = "small"
                    fullWidth
                    sx={{width: '100%'}}
                    label={'Data de Cadastro'} 
                    ampm={false} 
                    value={dayjs.tz(values?.CREATED_AT_GERENTE)}
                    enabled={false}
                    format="DD/MM/YYYY" 
                />
                <DateField 
                    size = "small"
                    fullWidth
                    sx={{width: '100%'}}
                    label={'Início da Manutenção'} 
                    ampm={false} 
                    value={dayjs.tz(values?.START_MANUTENTION)}
                    format="DD/MM/YYYY" 
                />
            </LocalizationProvider>
        </div>
        <div className="grid grid-cols-1 gap-2 lg:grid-cols-3 md:grid-cols-2 mt-2"> 
            <TextField 
                size = "small"
                fullWidth
                value={Number(values?.MANUTENTION_VALUE  || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })} 
                label="Valor de Manutenção" 
                 
            />
            <TextField 
                size = "small"
                fullWidth
                value={Number(values?.MANUTENTION_TOTAL_ORIGINAL  || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })} 
                label="Total em Manutenção" 
            />
            <TextField 
                size = "small"
                fullWidth
                value={Number(values?.SALES_TOTAL  || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })} 
                label="Total em Vendas" 
            />  
        </div>
        <TextField 
            label="Total Geral"
            size = "small"
            fullWidth        
            value={(Number(values?.SALES_TOTAL  || 0) + Number(values?.MANUTENTION_TOTAL_ORIGINAL  || 0)).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}  
        />  
        <Divider sx={{ color: useTheme().palette.primary.main }} className=" font-bold">
            Histórico de Vendas - Período
        </Divider>
        <ClientesSalesTable client={props.client} startDate={startDate} endDate={endDate} />
    </div>

  )
}

export default ClienteFinanceDetails;